import { formatDate } from '../../../../helpers/date'
import { EventLog, EventLogDataItem } from '../../../entities/EventLog/EventLog'
import { getCategoryName, translateCategoryEnum } from '../../../entities/EventLog/EventLogHelpers'
import trans from '../../../helpers/trans'

export interface LogsDateObjectProps {
    [key: string]: EventLog[]
}

export const generateLogsDateObject = (events: EventLog[]): LogsDateObjectProps => events
    .reduce((total: LogsDateObjectProps, log: EventLog) => {
        const date = formatDate(log.updatedAt, 'yyyy-MM-dd')

        return {
            ...total,
            [date]: [
                ...total[date] || [],
                log,
            ],
        }
    }, {})

export interface DetailLog<T> {
    key: string;
    field: string;
    value: T;
}

export const convertDataItemObjectToValues = <T>(dataItem: EventLogDataItem): DetailLog<T>[] => {
    const data = Object.entries(dataItem.data)

    return data.flatMap(([key, value]) => {
        const values = Object.entries(value)

        return values.map(([field, change]) => {
            const category = translateCategoryEnum(key)
            const fieldValue = field !== '0' ? field : undefined
            let categoryName = getCategoryName(category, fieldValue)

            if (! categoryName) {
                console.warn('Missing event log category name for fieldValue \'%s\'', fieldValue)
                categoryName = `${fieldValue}`
            }

            let changeValue = change

            if (typeof change === 'object' && change !== null && 'transKey' in change) {
                changeValue = trans((change as any).transKey, (change as any).transOptions)
            }

            return {
                key: category,
                field: categoryName,
                value: changeValue as T,
            }
        })
    })
}
